const state = {
  toggle_edit_modal: false,
  reason_id: null
}

const getters = {}

const mutations = {
  setReasonId (state, reason_id) {
    state.reason_id = reason_id
  },
  toggleEditModal (state) {
    state.toggle_edit_modal = !state.toggle_edit_modal
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
